import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL_SERVICIOS } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class HistorialService {

  totalRegistro = 0;

  constructor(private http: HttpClient) { }




  getMuestraHistorial( desde: number = 0, finicio: Date, ffin: Date) {
    const url = URL_SERVICIOS + '/historial/historial/' + desde + '/' + finicio + '/' + ffin;
    return this.http.get (url)
    .map ((resp: any) => {
        this.totalRegistro = resp.totalregistros;
        console.log ('datos recibidos', resp.data);
        return resp.data;
    });
  }


  getborraHistorial(  finicio: string, ffin: string) {
    const url = URL_SERVICIOS + '/borrar/'  + finicio + '/' + ffin;
    return this.http.get (url)
    .map ((resp: any) => {
        this.totalRegistro = resp.totalregistros;
        console.log ('datos recibidos', resp.data);
        return resp.data;
    });
  }

  // este procedimienot transfiere la informacion de prehistorial al historial a traves de un boolean
  transfiereHistorial(  folioinicial: string, foliofinal: string) {
    const url = URL_SERVICIOS + '/borrar/actualizahistorial/'  + folioinicial + '/' + foliofinal;
    return this.http.get (url)
    .map ((resp: any) => {
        this.totalRegistro = resp.totalregistros;
        console.log ('datos recibidos', resp.data);
        return resp.data;
    });
  }

}
